module.exports = __webpack_public_path__ + "static/media/hero-5.4c4e4b2f.jpg";